import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'app-loading-spinner',
    standalone: true,
    imports: [CommonModule],
    styleUrls: ['./loading-spinner.component.scss'],
    templateUrl: './loading-spinner.component.html'
})
export class LoadingSpinnerComponent {
    @Input() overlay = false;
    @Input() type: 'lines' | 'grid' | 'detail' | 'project-cards' | 'project-detail' = 'lines';
    @Input() count = 5;

    get _items(): number[] {
        return Array.from({ length: this.count }, (_, i) => i);
    }
    get _items3(): number[] {
        return [0, 1, 2];
    }
}
